export const equalParams = (p1?: string | null, p2?: string | null) => {
  const nulls = ['', undefined, null];
  if (p1 === p2) return true;
  if (nulls.includes(p1) && nulls.includes(p2)) return true;

  return false;
};

export const buildURL = (path: string, searchParams: URLSearchParams = new URLSearchParams()): string => {
  let newPath: string = path;

  if ([...searchParams?.keys()].length > 0) newPath += `?${searchParams?.toString()}`;

  return newPath;
};
